import { AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';

export function namePatternValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    // required validator handles empty case
    if (!value) {
      return null;
    }

    const namePattern = /^(?=.*\p{L})[\p{L}'’\- ]{3,}$/u;

    return namePattern.test(value)
      ? null
      : { namePattern: true };
  };
}
